import type { ValidateResponse } from '$types/form';

export const acceptImportTypes = ['json'];

export type Registration = {
  email: string;
  fname: string;
  lname: string;
  phone: string;
  password: string;
  passwordConfirm: string;
  amount: string;
  amountCustom: string;
  address: string;
  terms: boolean;
  newsletter: boolean;
};

export function validate(data: Registration): ValidateResponse<Registration> {
  if (data.password !== data.passwordConfirm) {
    return { message: 'Hesla se neshodují', values: data };
  }
  if (data.password.length < 8) {
    return { message: 'Heslo musí mít alespoň 8 znaků', values: data };
  }
  if (!data.terms) {
    return { message: 'Musíte souhlasit s ochranou osobních údajů', values: data };
  }
  return null;
}
